<template>
  <div
    data-component-id="FindCandidate"
  >
    <v-card
      :style="`z-index: 10; position: sticky; top: ${focusModeToolbarTop};`"
      color="rgba(255, 255, 255, 0.8)"
    >
      <v-toolbar
        flat
        color="transparent"
      >
        <v-btn small icon fab class="px-0" text @click="$router.back()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-skeleton-loader
          type="text"
          min-width="200px"
          class="pl-4"
        >
          <v-toolbar-title>Rechercher un collaborateur</v-toolbar-title>
        </v-skeleton-loader>
        <v-spacer />
        <section
          class="d-flex align-center"
          style="gap: 32px;"
        >
          <v-fab-transition>
            <v-tooltip
              bottom
            >
              <template #activator="{ on }">
                <v-btn
                  icon
                  :class="{ 'pulse-animation': hasSearched && !items.length }"
                  :disabled="!canPerformAction('CREATE_PROSPECT')"
                  :to="{ name: 'add-candidate' }"
                  v-on="on"
                >
                  <v-icon>mdi-account-multiple-plus</v-icon>
                </v-btn>
              </template>
              <span>
                Créer un nouveau candidat
              </span>
            </v-tooltip>
          </v-fab-transition>
        </section>
      </v-toolbar>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      />
    </v-card>

    <section
      class="my-8 my-lg-16 px-4 px-md-8 pa-0 col-12"
      :class="{ 'mt-12' : focusMode }"
    >
      <DataIterator
        template="ListItemForCandidates"
        :list="items"
        show-assign-offer-button
        show-footer
      >
        <template #top>
          <section
            class="
              d-flex flex-column flex-md-row align-md-center
              py-0 pb-6
            "
            style="gap: 28px;"
          >
            <v-text-field
              v-model="searchQuery"
              outlined
              dense
              hide-details
              clearable
              prepend-inner-icon="mdi-magnify"
              placeholder="Recherche"
              transition="scale-transition"
              class="rounded-lg"
              @input="debouncedSearch"
              @click:clear="handleClearSearch"
            />
          </section>
        </template>
        <template #no-data>
          <div
            class="
              d-flex justify-center align-center
              rounded-lg py-4
              white font-weight-medium grey--text
            "
            style="height: 48px;"
          >
            Aucune donnée disponible
          </div>
        </template>
      </DataIterator>
    </section>
  </div>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue';

import store from '@/store';
import { useCollaboratorSearch } from '@/composables/useCollaboratorSearch';

import DataIterator from '@/components/table/DataIterator.vue';

const { proxy } = getCurrentInstance();
const vuetify = proxy.$vuetify;

const searchQuery = ref('');

const {
  items,
  isLoading,
  hasSearched,
  debouncedSearch,
  clearSearch
} = useCollaboratorSearch();

const focusMode = computed(() => store.state.focusMode);

const canPerformAction = action => store.getters.canPerformAction(action);

const focusModeToolbarTop = computed(() => {
  if (vuetify.breakpoint.xsOnly) {
    return '64px';
  }
  return focusMode.value ? '24px' : '88px';
});

const handleClearSearch = () => {
  searchQuery.value = '';
  clearSearch();
};
</script>

<style scoped>
.pulse-animation:before {
  animation: opacityPulse 1.5s infinite;
  background-color: red;
  opacity: 0.08;
}

.pulse-animation:hover:before {
  animation-play-state: paused;
}

@keyframes opacityPulse {
  50% { opacity: 0 }
}
</style>
